import { useTranslation } from "react-i18next";

import { defaultNS } from "@/lib/i18n";

export function useDeviceType() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "domain.device.type",
  });
  const { t: tShort } = useTranslation(defaultNS, {
    keyPrefix: "domain.device.type.short",
  });

  return { t, tShort };
}
